<div class="banner" role="banner">
  <h1>{{ 'contact.us.page.title' | translate }}</h1>
</div>

<fgbcl-contact-us></fgbcl-contact-us>
